import { render, staticRenderFns } from "./arreval.vue?vue&type=template&id=6ecf8066&scoped=true"
import script from "./arreval.vue?vue&type=script&lang=js"
export * from "./arreval.vue?vue&type=script&lang=js"
import style0 from "./arreval.vue?vue&type=style&index=0&id=6ecf8066&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecf8066",
  null
  
)

export default component.exports